import { Auth0Client } from '@auth0/auth0-spa-js';
export const ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME = 10;
export async function auth0ClientFactory(config) {
    const auth0 = new Auth0Client({
        domain: config.authority,
        clientId: config.clientId,
        authorizationParams: {
            audience: config.audience,
            scope: config.requiredScopes.join(' '),
            redirect_uri: `${window.location.origin}/oauth/callback`,
        },
        cacheLocation: 'localstorage',
        useRefreshTokens: false,
    });
    return auth0;
}
//# sourceMappingURL=auth0.client.factory.js.map